import React from "react";
import PillWithIconFake from "@/components/Fakes/pill-with-icon-fake";
import styles from "./styles.js";

const FakeGeneralManagment = () => {
  return (
    <>
      <div className="container">
        <div className="general-managment-fake">
          <div className="general-managment-fake--container">
            <div className="skeleton general-managment-fake--title" />
            <div className="general-managment-fake--container--box-container">
              <div className="skeleton general-managment-fake--container--box" />
              <div className="skeleton general-managment-fake--container--box" />
            </div>
          </div>
          <div className="general-managment-fake--container">
            <div className="skeleton general-managment-fake--title" />
            <div className="general-managment-fake--second--box">
              <PillWithIconFake border />
              <PillWithIconFake border />
              <PillWithIconFake border />
            </div>
          </div>
          <div className="skeleton general-managment-fake--footer" />
        </div>
      </div>
      <style jsx>{styles}</style>
    </>
  );
};

export default FakeGeneralManagment;
